import React, { useEffect } from 'react';
import WpSelectV2 from 'Wpds/components/select/WpSelectV2';
import { Moment } from 'moment';

import './RecurrenceTimeInMonthInput.scss';

// const selectStyles = {
//   control: base => ({ ...base, height: '100%', minHeight: '30px', alignItems: 'baseline' }),
//   valueContainer: base => ({ ...base, height: '100%' }),
//   indicatorsContainer: base => ({ ...base, height: '100%' }),
//   input: base => ({ ...base, height: '20px', display: 'flex', alignItems: 'center' }),
// };

type Props = {
  label?: string;
  startsAt: Moment;
  dayInMonth: number;
  weekInMonth: number;
  onDayInMonthChange: Function;
  onWeekInMonthChange: Function;
};

function RecurrenceTimeInMonthInput({ label, startsAt, dayInMonth, onDayInMonthChange, onWeekInMonthChange }: Props) {
  const dayInMonthForStartDate = startsAt.date() - 1;
  const weekInMonthForStartDate = (() => {
    const startsAtDayInWeek = startsAt.isoWeekday();
    const beginningInMonthOfStartsAt = startsAt.clone().startOf('month');
    const allDatesOfDayInMonth = Array.from(Array(startsAt.daysInMonth()).keys())
      .map(dayOffset => beginningInMonthOfStartsAt.clone().add(dayOffset, 'days'))
      .filter(dateInMonth => dateInMonth.isoWeekday() === startsAtDayInWeek)
      .map(dateInMonth => dateInMonth.date() - 1);
    if (allDatesOfDayInMonth.indexOf(dayInMonthForStartDate) === allDatesOfDayInMonth.length - 1) return -1;
    else return allDatesOfDayInMonth.indexOf(dayInMonthForStartDate);
  })();

  const weekInMonthForStartDateHumanizeMap = {
    '0': 'first',
    '1': 'second',
    '2': 'third',
    '3': 'fourth',
    '4': 'fifth',
    '-1': 'last',
  };

  const selectOptions = [
    { label: `Day ${dayInMonthForStartDate + 1}`, value: 'day_in_month' },
    {
      label: `the ${weekInMonthForStartDateHumanizeMap[weekInMonthForStartDate]} ${startsAt.format('dddd')}`,
      value: 'week_in_month',
    },
  ];
  const selectValue = dayInMonth !== null ? selectOptions[0].value : selectOptions[1].value;

  const onSelectChange = option_value => {
    if (option_value === 'day_in_month') {
      onDayInMonthChange(dayInMonthForStartDate);
      onWeekInMonthChange(null);
    } else {
      onWeekInMonthChange(weekInMonthForStartDate);
      onDayInMonthChange(null);
    }
  };

  useEffect(() => {
    onSelectChange(selectValue);
  }, [startsAt]);

  return (
    <div className={`d-flex align-items-center mb-2 mt-1`}>
      {label && <span className="mr-2">{label}</span>}
      <WpSelectV2
        label=""
        id="recurrence-time-in-month-select"
        options={selectOptions}
        value={selectValue}
        onChange={onSelectChange}
        forceReset
      />
    </div>
  );
}

export default RecurrenceTimeInMonthInput;
